export default {
  init() {
    $(document).ready(function (){
      $('.review__slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        autoplay: false,
        autoplaySpeed: 2000,
        dots: true,
      });

    });

    $('.review__slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      // console.log(nextSlide);
      $('.hexagon-left, .hexagon-right').addClass('hexagon' + nextSlide);
      $('.hexagon-left, .hexagon-right').removeClass('hexagon' + currentSlide);
    });
  },

  // JavaScript to be fired on all pages, after page specific JS is fired
  finalize() {
  },
};
